/* kickflip-cart-guard.js
   Katana Canada - Intercepte Kickflip et ouvre Opus Cart Upsell
   Version: 1.0 | Date: 2025-01-29
*/
(function () {
  'use strict';
  
  const DEBUG = false;
  const KICKFLIP_ORIGIN = 'gokickflip.com';
  
  function log(...args) {
    if (DEBUG) console.log('[KickflipGuard]', ...args);
  }
  
  window.addEventListener('message', function(event) {
    if (!event.origin || !event.origin.includes(KICKFLIP_ORIGIN)) return;
    if (!event.data || event.data.eventName !== 'mczrAddToCart') return;
    
    log('INTERCEPTED mczrAddToCart!');
    event.stopImmediatePropagation();
    
    const detail = event.data.detail;
    if (!detail || !detail.id) return;
    
    handleAddToCart(detail);
  }, true);
  
  
  async function handleAddToCart(designDetail) {
    try {
      const customizerIframe = document.querySelector('kickflip-customizer-iframe');
      if (!customizerIframe) return;
      
      const brand = customizerIframe.getAttribute('brand');
      const shopifyProductId = customizerIframe.getAttribute('shopifyProductId');
      const shopifyVariantId = customizerIframe.getAttribute('shopifyVariantId');
      const countryIsoCode = customizerIframe.getAttribute('countryIsoCode');
      
      // Get cart properties from Kickflip API
      const response = await fetch(
        `/apps/kickflip/designs/${designDetail.id}/cart-properties?brand=${brand}&productId=${shopifyProductId}&countryIsoCode=${countryIsoCode}`
      );
      const cartProps = await response.json();
      
      // Build cart body
      let body;
      if (cartProps.strategy === 'function') {
        const attributes = [
          { key: '_mczr_image', value: cartProps.image },
          { key: '_mczr_designId', value: cartProps.designId },
          { key: '_mczr_mczrStoreId', value: cartProps.mczrStoreId },
          { key: '_mczr_brand', value: cartProps.brand }
        ];
        if (cartProps.summary_v2) {
          cartProps.summary_v2.forEach(item => {
            if (item.key && item.value != null) {
              attributes.push({ key: item.key, value: String(item.value) });
            }
          });
        }
        body = {
          items: [{
            quantity: 1,
            id: shopifyVariantId,
            properties: {
              'Design': cartProps.designId,
              '_mczr_image': cartProps.image,
              '_mczr_designId': cartProps.designId,
              '_mczr_designProtectionToken': cartProps.designProtectionToken,
              '_mczr_price': cartProps.price,
              '_mczr_hashedPrice': cartProps.hashedPrice,
              '_mczr_variants': JSON.stringify((cartProps.variants || []).map(v => ({ id: v.id, quantity: v.quantity }))),
              '_mczr_attributes': JSON.stringify(attributes)
            }
          }]
        };
      } else {
        const props = cartProps.props || cartProps;
        body = {
          items: [{
            quantity: 1,
            id: props.variant?.id || shopifyVariantId,
            properties: {
              'Design': props.designId,
              '_mczr_image': props.image,
              '_mczr_designId': props.designId,
              '_mczr_designProtectionToken': props.designProtectionToken,
              '_mczr_mczrStoreId': props.mczrStoreId,
              '_mczr_brand': props.brand
            }
          }]
        };
      }
      
      // Add to cart
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      
      if (!addResponse.ok) throw new Error('Add to cart failed');
      
      // Close Kickflip modal
      const modal = document.querySelector('kickflip-customizer-modal');
      if (modal && modal.hide) modal.hide();
      document.body.classList.remove('kickflip-overflow-hidden');
      
      // Open Opus Cart via cart icon click
      setTimeout(function() {
        const cartIcon = document.querySelector('#cart-icon-bubble') ||
                         document.querySelector('.cart-icon-bubble') ||
                         document.querySelector('a[href="/cart"]');
        if (cartIcon) {
          cartIcon.click();
        } else if (window.opusOpen) {
          window.opusOpen();
        }
      }, 500);
      
    } catch (e) {
      log('ERROR:', e);
    }
  }
})();